import { FormEvent } from "react";
import { Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { CheckMeOut, EmailAddress, FloatingFormTitle, Password, SignIn } from "../../../../../Constants/Constants";
import { FloatingFormSubTitle } from "../../../../../Data/Forms&Table/Forms/FormControls";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonCheckbox from "../../Common/CommonCheckbox";

const FloatingForm = () => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => event.preventDefault();
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={FloatingFormTitle} span={FloatingFormSubTitle} />
        <CardBody>
          <div className="card-wrapper border rounded-3">
            <Form onSubmit={handleSubmit} className="floating-wrapper">
              <Row className="g-3">
                <Col xs="12">
                  <FormGroup floating>
                    <Input type="email" />
                    <Label>{EmailAddress}</Label>
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup floating>
                    <Input type="password"/>
                    <Label>{Password}</Label>
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup check className="checkbox-checked">
                    <CommonCheckbox title={CheckMeOut} inputType="checkbox" check />
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <Btn color="primary">{SignIn}</Btn>
                </Col>
              </Row>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default FloatingForm;
